import React from "react";
import { Link } from "react-router-dom";

const Failed = () => {
  return (
    <>
      <div className="tf-page-title style-2">
        <div className="container-full">
          <div className="heading text-center">Failed</div>
        </div>
      </div>
      <section className="flat-spacing-25">
        <div className="container">
          <div className="tf-main-area-page">
            <div className="text-center pb-lg-17 pb-13 mb-3">
              <h6> Payment Failed. Please try again</h6>
              <div>
                <Link
                  to="/"
                  className="btn btn-dark btn-hover-bg-primary btn-hover-border-primary px-11 mt-md-7 mt-4"
                >
                  {" "}
                  Go Back to Cart
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Failed;
